import React from 'react'
import Link from 'gatsby-link'
import slugify from 'slugify'

class CategoryItem extends React.Component {
  render() {
    const {activeCategory} = this.props;
    const {name, description, projects} = this.props.cat.node;
    const slug = slugify(name, { lower: true })
    const categoryIsActive = activeCategory === slug;
    let categoryIsActiveClass = ' ';
    if (categoryIsActive) { categoryIsActiveClass = 'active' }

    return (
      <div className={`category-wrapper ${categoryIsActiveClass}`}>

        <div>

          <div id={`${slug}`} className="id-marker"/>

          {categoryIsActive &&
            <span className="category-name-button">-</span>
          }

          {!categoryIsActive &&
            <span className="category-name-button">+</span>
          }

          <span onClick={this.handleClick.bind(this)} className="category-name">{name}</span>

          {categoryIsActive && description &&
            <div className="category-description" dangerouslySetInnerHTML={{
              __html: description.childMarkdownRemark.html,
            }}>
            </div>
          }

          <div className="projects-list">
            {projects.map((proj, i) => {
              return (
                <div key={i} className="project-wrapper">
                  <Link className="project-link" to={`/${proj.slug}`}>
                    <div className="text">
                      <h4>{proj.title}</h4>

                      <p>{proj.shortDescription}</p>
                    </div>

                    <img src={proj.imageThumbnail.file.url} />
                  </Link>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  handleClick(){
    const {handleClick} = this.props;
    const {name} = this.props.cat.node;
    const slug = slugify(name, { lower: true })

    handleClick(slug)
  }
}

export default CategoryItem



// WEBPACK FOOTER //
// ./src/components/category-item.js